import styled from 'styled-components';
export const DocumentViewWrapper = styled.div `
  color: #000;
  position: absolute;
  text-align: center;
  height: 100%;
  width: 100%;

  .imageBox {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .imageBox canvas {
    background: #fff;
    box-shadow: 3px 6px 4px 0 rgba(30, 30, 30, 0.5);
  }

  .image-page {
    margin-bottom: 24px;
  }

  .image-page:last-child {
    margin-bottom: 0;
  }
  .PrintFrame {
    visibility: hidden;
    height: 0;
    width: 0;
    position: absolute;
    bottom: 0;
  }

  .documentTitle {
    font-size: ${(props) => props.theme.fontSmall};
    line-height: 14px;
    word-break: break-all;
    margin-bottom: 2px;
    margin-top: 1rem;
  }

  .documents-container {
    overflow-x: auto;
    height: 100%;
    position: relative;
    padding-bottom: 50px;
    padding-top: 0;
  }
`;
